var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"ol-route-zoom ol-unselectable ol-control\">\n  <button type=\"button\" ng-click=\"map.overview()\">{{ t('fleetDashOverview') }}</button>\n  <div ng-if=\"map.route\" class=\"ol-divider\"></div>\n  <button ng-if=\"map.route\" type=\"button\" ng-click=\"map.zoomToFitRoute()\">{{ t('fleetDashRouteOverview') }}</button>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/routeZoomControl.jade
 ** module id = 104
 ** module chunks = 1
 **/